import { ajaxAuth } from "@tm/utils"
import { VehicleRecordDataSources } from "@tm/data/vehicleRecords/models"
import { WebserviceUrl } from "@tm/data/webserviceUrls"

export async function showVehicleRecordDataSources(vehicleId: string): Promise<VehicleRecordDataSources | undefined> {
    return ajaxAuth({
        url: `${WebserviceUrl.VehicleRecordsVehicle}/ShowVehicleRecordsDataSources`,
        body: { vehicleId },
    })
}
